
const url_server = (window.location.port==3000 ? "http://"+ window.location.hostname +":3035/"  :"/" );

export default url_server;